import store from "../../store/index";
import apiOffice from "../axios/apiOffice";

class CommunicationsService {
  static async getMassNotiReport(idNoti) {
    try {
      const response = await apiOffice.get(
        `/communications/mass-noti-report/${idNoti}`,
        {
          responseType: "blob",
        }
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting report noti:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async sendMassiveCommunication(body) {
    try {
      const response = await apiOffice.post(
        `/communications/send-massive-communication/${store.state.CidiCookie}`,
        body
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error sending mass commnunication:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async sendIndividualCommunication(body) {
    try {
      const response = await apiOffice.post(
        `/communications/send-cidi-communication/${store.state.CidiCookie}`,
        body
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error sending mass commnunication:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getMyCommunications(page = 1) {
    try {
      const response = await apiOffice.get(
        `/communications/my-communications?page=${page}`
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting my communications:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getSentCommunications(userId, filters) {
    try {
      const response = await apiOffice.get(`/communications/user/${userId}`, {
        params: filters,
      });
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting sent communicationes:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async markAsRead(ids = []) {
    try {
      const response = await apiOffice.patch(
        `/communications/mark-as-read`,
        {ids: ids }
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error marking as read:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default CommunicationsService;
